/* eslint-disable */
export const truespeedScema = `module truespeed {
    namespace "http://viavisolutions.com/ns/yang/truespeed/2016-06-08";
    prefix "truespeed";
 
    organization "Viavi Solutions"; 
    contact "justin.robbins@viavisolutions.com"; 
    description "The module for TrueSpeed test sequence."; 
    revision "2016-06-08" {
        description "Initial version"; 
        reference "";
    }
    grouping engine-info {
    	description "Engine information";
        leaf engine-type {
        	type enumeration {
        		enum vprobe {
        			description "";
        		}
        		enum client {
        			description "";
        		}
        	}
        	description "Engine type selection";
        }
        leaf address {
            when "../engine-type != 'client'";
            type uint32;
            description "Management IP address"; 
        }
        leaf port { 
            when "../engine-type != 'client'";
            type uint32;
            default "12";
            description "Management port";
        }
    }
    grouping tos-dscp-value {
    	description "";
    	leaf type {
    		type enumeration {
    			enum tos {
    				description "";
    			}
    			enum dscp {
    				description "";
    			}
    		}
    		default "tos";
    		description "";
    	}
    	leaf tos {
    		when "../type = 'tos'";
    		type uint32 {
    			range "0..255";
    		}
    		default "0";
    		description "TOS bits";
    	}
    	leaf dscp {
    		when "../type = 'dscp'";
    		type uint32 {
    			range "0..63";
    		}
    		default "0";
    		description "DSCP mapped value";
    	}
    }
    grouping truespeed-window-results {
    	leaf window-id {
    		type uint32 {
    			range "0..10";
    		}
    		description "Window ID for result correlation";
    	}
    	leaf bdp {
    		type uint64;
    		description "BDP computed for this window";
    	}
    	leaf window-size {
    		type uint64;
    		description "Window size used in KB";
    	}
    	leaf connections {
    		type uint64;
    		description "Number of connections used";
    	}
    	leaf avg-thruput {
    		type decimal64 {
                    fraction-digits "1";
                }
    		description "Average throughput measured in Mbps";
    	}
    	leaf peak-thruput {
    		type decimal64 {
                    fraction-digits "1";
                }
    		description "Peak throughput measured in Mbps";
    	}
    	leaf ideal-thruput {
    		type decimal64 {
                    fraction-digits "1";
                }
    		description "Ideal/target throughput in Mbps";
    	}
    	leaf rate-under-test {
    		type decimal64 {
                    fraction-digits "1";
                }
    		description "The rate tested for this BDP in Mbps";
    	}
    	leaf buffer-delay {
    		type decimal64 {
                    fraction-digits "2";
                }
    		description "Buffer delay percentage metric";
    	}
    	leaf tcp-efficiency {
    		type decimal64 {
                    fraction-digits "2";
                }
    		description "TCP efficiency percentage metric";
    	}
    	leaf originator {
    		type enumeration {
    			enum engine-a {
    				description "";
    			}
    			enum engine-b {
    				description "";
    			}
    		}
    		description "";
    	}
    	leaf exceeded-retransmit-threshold {
    		type boolean;
    		description "Whether the re-transmit threshold was exceeded";
    	}
    	leaf rtt-avg {
    		type decimal64 {
                    fraction-digits "3";
                }
    		description "Average round-trip delay in milliseconds";
    	}
    }
    container sequence {
	    container configs {
		container engine-a-info {
		        uses engine-info;
		        description "Engine A information";
		}
		container engine-b-info {
		        uses engine-info;
		        description "Engine B information";
                }
                container truespeed-parameters {
                    leaf tcp-port {
                            type uint32;
                            description "TCP destination port for test traffic";
                    }
                    leaf engine-a-to-b-cir {
                            type decimal64 {
                                fraction-digits 1;
                            }
                            description "CIR for traffic generated from engine A to engine B in Mbps";
                    }
                    leaf engine-b-to-a-cir {
                            type decimal64 {
                                fraction-digits 1;
                            }
                            description "CIR for traffic generated from engine B to engine A in Mbps";
                    }
                    leaf window-duration {
                            type uint32{
								range "15..360";
								}
                            description "Window duration in seconds";
                    }
                    leaf connections {
                            type uint32 {
                                    range "1..64";
                            }
                            default 1;
                            description "Number of connections to run the test using or 0 to automatically determine";
                    }
                    leaf num-windows {
                            type uint32 {
                                    range "0..10";
                            }
                            default 3;
                            description "Number of window walks to run in each direction";
                    }
                    leaf percent-start-window-walk {
                            type uint32 {
                                    range "1..100";
                            }
                            default 50;
                            description "Starting percentage for walk-the-window test. Window walk percentage will be automatically computed between this value and 100% of CIR.";
                    }
                    leaf run-saturation-window {
                            type boolean;
                            default "false";
                            description "Run additional saturation window each direction";
                    }
                    leaf percent-over-saturate-window {
                            when "../run-saturation-window = 'true'";
                            type uint32 {
                                    range "0..100";
                            }
                            default "0";
                            description "Percent to over-saturate the window size used in saturation test";
                    }
                    leaf percent-over-saturate-connections {
                            when "../run-saturation-window = 'true'";
                            type uint32 {
                                    range "0..100";
                            }	
                            default "0";
                            description "Percent to over-saturate the number of connections used in saturation test";
                    }
                    leaf retransmit-threshold {
                            type uint32 {
                                    range "0..50";
                            }
                            default "50";
                            description "Abort the test if re-transmit exceeds this percentage for some defined period";
                    }
                    leaf retransmit-duration {
                            type uint32 {
                                    range "5..10";
                            }
                            default "10";
                            description "Abort the test if the # of re-transmits exceeds threshold within this specified period in seconds";
                    }
                    leaf bdp-table-version {
                            type uint32 {
                                    range "1..2";
                            }
                            default "1";
                            description "BDP table version to use";
                    }
                    container tos-dscp {
                            uses tos-dscp-value;
                            description "TOS/DSCP for TCP traffic";
                    }
                    description "";
                }
                description "";
	    }
	    container results {
	    	config false;
	    	container truespeed {
	    		list results {
	    			leaf timestamp {
				        description "";
			        }
			        leaf type {
				        type enumeration {
				            enum truespeed-results {
				            	description "";
				            }
				            enum truespeed-update {
				            	description "";
				            }
				            enum truespeed-prediction {
				            	description "";
				            }
				            enum progress-update {
				            	description "";
				            }
				        }
				        description "Object type info";       	
				    }
				    leaf progress-message {				    		
				        when "../type = 'progress-update'" {
				        	description "";
				        }
				        type string;
				        description "Progress message";
				    }
				    leaf window-id {
				    	when "../type = 'truespeed-prediction' or ../type = 'truespeed-update'" {
				    		description "";
				    	}
				    	type uint32 {
				    		range "0..10";
				    	}
				    	description "Window ID for result correlation";
				    }
				    leaf window-size {
				    	when "../type = 'truespeed-prediction'" {
				    		description "";
				    	}
				    	type uint32;
				    	description "Window size in KB being used for the window test";
				    }
				    leaf connections {
						when "../type = 'truespeed-prediction'" {
				    		description "";
				    	}
				    	type uint32;
				    	description "Number of connections being used for the window test";
				    }
				    leaf originator {
				    	when "../type = 'truespeed-prediction'" {
				    		description "";
				    	}
				    	type enumeration {
				    		enum engine-a {
				    			description "";
				    		}
				    		enum engine-b {
				    			description "";
				    		}
				    	}
				    	description "";
				    }
				    leaf predicted-thruput {
				    	when "../type = 'truespeed-prediction'" {
				    		description "";
				    	}
				    	type decimal64 {
				    		fraction-digits 1;
				    	}
				    	description "Predicted throughput in Mbps";
				    }
				    leaf delay-start-time {
				    	when "../type = 'truespeed-prediction'" {
				    		description "";
				    	}
				    	type uint32;
				    	description "Delay start time offset being used";
				    }
				    leaf expected-duration {
				    	when "../type = 'truespeed-prediction'" {
				    		description "";
				    	}
				    	type uint32;
				    	description "Expected length in seconds for the individual window run";
				    }
				    leaf current-thruput {
				    	when "../type = 'truespeed-update'" {
				    		description "";
				    	}
				    	type decimal64 {
                                            fraction-digits "1";
                                        }
				    	description "Current/instantaneous throughput in Mbps";
				    }
				    leaf current-rtt {
				    	when "../type = 'truespeed-update'" {
				    		description "";
				    	}
				    	type decimal64 {
                                            fraction-digits "2";
                                        }
				    	description "Current/instantaneous round-trip delay in milliseconds";
				    }
				    leaf current-retransmitted-frames {
				    	when "../type = 'truespeed-update'" {
				    		description "";
				    	}
				    	type uint64;
				    	description "Current number of re-transmitted frames";
				    }
				    leaf current-transmitted-frames {
				    	when "../type = 'truespeed-update'" {
				    		description "";
				    	}
				    	type uint64;
				    	description "Current number of transmitted frames";
				    }
				    leaf mtu {
				    	when "../type = 'truespeed-results'" {
				    		description "";
				    	}
				    	type uint32;
				    	description "Discovered MTU size in bytes";
				    }
				    leaf mss {
				    	when "../type = 'truespeed-results'" {
				    		description "";
				    	}
				    	type uint32;
				    	description "Discovered MSS in bytes";
				    }
				    leaf rtt {
				    	when "../type = 'truespeed-results'" {
				    		description "";
				    	}
				    	type decimal64 {
                                            fraction-digits "1";
                                        }
				    	description "Baseline round-trip time metric in milliseconds";
				    }
				    leaf possible-proxy-detected {
				    	when "../type = 'truespeed-results'" {
				    		description "";
				    	}
				    	type boolean;
				    	description "Whether a possible proxy was detected";
				    }
				    leaf using-high-accuracy-metrics {
				    	when "../type = 'truespeed-results'" {
				    		description "";
				    	}
				    	type boolean;
				    	description "Whether results were gathered with high-accuracy metrics";
				    }
				    leaf engine-a-to-b-diagnosis {
				    	when "../type = 'truespeed-results'" {
				    		description "";
				    	}
				    	type string;
				    	description "Engine A to engine B TCP doctor diagnosis";
				    }
				    leaf engine-b-to-a-diagnosis {
				    	when "../type = 'truespeed-results'" {
				    		description "";
				    	}
				    	type string;
				    	description "Engine B to engine A TCP doctor diagnosis";
				    }
				    container window-results {
				        list window-results-list {
				        uses truespeed-window-results;
				        key window-id;
				            description "";
				        }
				        when "../type = 'truespeed-results'" {
				            description "";
				        }
				        description "";
				    }
	    		}
	    	}
	    	description "";
	    }
	    container state {
			leaf id {
				type string;
				description "Workflow ID";
			}
			leaf state {
				type enumeration {
					enum stopping {
						description "";
					}
					enum stopped {
						description "";
					}
					enum waiting {
						description "";
					}
					enum running {
						description "";
					}
					enum aborted {
						description "";
					}
					enum failed-to-initialize {
						description "";
					}
				}
				description "The current state of the workflow";
			}
			leaf failure-reason {
				type string;
				description "";
			}
			config false;
			description "";
		}
		description "";
    }
    rpc workflow-actions {
    	description "";
		input {
			choice action-type {
				case start {
					leaf start {
						type empty;
						description "Start specified workflow";
					}
				}
				case stop {
					leaf stop {
						type empty;
						description "Stop specified workflow";
					}
				}
				description "";
			}
		}
		output {
			choice action-type {
				case start {
					leaf start-status {
						type enumeration {
							enum success {
								description "";
							}
							enum already-in-state {
								description "";
							}
						}
						description "";
					}
				}
				case stop {
					leaf stop-status {
						type enumeration {
							enum success {
								description "";
							}
							enum already-in-state {
								description "";
							}
						}
						description "";
					}
				}
				description "";
			}
		}
    }
}`;
